// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2PLlt","insightsList":"newBusinessInsightsMenu_insightsList__3uQaQ","active":"newBusinessInsightsMenu_active__1mZ42"};